<template>
  <main class="c-home main-contain" id="pg-business-funding">
    <section id="home-banner" class="parallax-background" data-paroller-factor="-0.09" data-paroller-factor-sm="-0.09" data-paroller-factor-xs="-0.09" :style="{ background: 'url('+ banner +') no-repeat center top'}">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="banner_description">
              <h1 class="white-c-1">We're Here <br/> to Help</h1>
              <p class="white-c-1 font-regular">If you’ve reviewed our Frequently Asked Questions but still have questions, please contact us.</p>
              <a href="#ContactMain" class="banner_scroll" >Scroll down to explore</a>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="ContactMain">
      <div class="container">
        <div class="row">
          <div class="col-md-7 matchHeight">
              <div class="padd-tb85">
                <h1 class="font-bold  mar-no blue-c-3">Contact Us</h1>
                <p class="padd-t30 font-regular justify">Fill-out the form below to get in contact with a Financial Adviser today!</p>

                <div id="ContactFormWrap">
                  <form name="contactForm" id="contactForm"  @submit.prevent="processForm">
                      <div class="row">
                        <div class="col-sm-12">
                          <div id="form-result"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('first_name')" class="help is-danger">{{ errors.first('first_name') }}</span>
                            <input type="text" name="first_name" id="first_name" placeholder=" " v-model="first_name" v-validate="'required'" >
                            <label for="first_name">First Name *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('last_name')" class="help is-danger">{{ errors.first('last_name') }}</span>
                            <input type="text" name="last_name" id="last_name" placeholder=" " v-model="last_name" v-validate="'required'" >
                            <label for="last_name">Last Name *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                            <input type="email" name="email" id="email" placeholder=" " v-model="email" v-validate="'required|email'" >
                            <label for="email">Email *</label>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="field">
                            <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
                            <input type="tel" name="phone" id="phone" placeholder=" " v-model="phone" v-validate="'required|numeric'" >
                            <label for="phone">Phone *</label>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="field">
                            <textarea name="address" id="address" placeholder=" " rows="4"></textarea>
                            <label for="address">Address</label>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="field">
                            <textarea name="message" id="message" placeholder=" " rows="6"></textarea>
                            <label for="message">Message</label>
                          </div>
                        </div>

                        <div class="col-sm-12">
                          <div class="padd-tb15">
                            <label class="big"><input type="checkbox" name="subscribe_for_newsletter" id="subscribe_for_newsletter" value="1" />  I agree to receive emails and updates from Dan Advance.</label>
                          </div>
                        </div>


                        <div class="col-sm-12">
                           <div class="field">
                            <vue-recaptcha sitekey="6LcVxrEUAAAAADs2q17NSpuTo9YEMI361EVDCW3J"  :loadRecaptchaScript="true"></vue-recaptcha>
                           </div>
                        </div>


                        <div class="col-sm-6">
                          <div class="padd-tb15">
                            <button class="" id="SubmitContact">Submit</button>
                          </div>
                        </div>

                      </div>
                    </form>
                </div>


              </div>
          </div>
          <div class="col-md-4 col-md-offset-1 matchHeight" id="BlueLion">
            <div class="BlueContentWrap centerAlign">

              <ul class="font-regular">
                <li><span>24-Hour Response Time</span></li>
                <li><span>Dan Advance works hard to ensure that our systems are secure and that they meet industry standards</span></li>
                <li><span>No Question Is A Wrong Question</span></li>
                <li><span>You need financial advice? We’re here for you!</span></li>
              </ul>
              <p><br/><br/></p>
            </div>
          </div>
        </div>
      </div>
    </section>





  </main>
</template>
<script>

import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VeeValidate);

export default{
  name: 'Home',
  components: {
    RwvSubscribe, VueRecaptcha
  },
  data: function() {
    return {
      banner:require('./../../static/images/contact-us.jpg'),
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
    }
  },
  mounted() {

  },
  methods: {
    processForm: function() {
      //console.log({ name: this.name, email: this.email });
      //alert('Processing!');

        this.$validator.validateAll().then((result) => {
        if (result) {
            //alert("success");
      
              //replace submit button with loader
              $( "#SubmitContact" ).fadeOut('fast', function(){
                  $( '<img src="'+ require('./../../static/images/loader.gif') +'" id="loader_gif" />' ).insertAfter(this);
              });

              // Send the data using post
              var form = $( "#contactForm" );  
              var posting = $.post('https://danadvance.com/cash/ajax/contact.php', form.serialize() );

              // Put the results in a div
              posting.done(function( data ) {
                var obj = $.parseJSON(data);
                $( "#form-result" ).empty().append( obj.msg );
                if(obj.success == 'true')
                {
                  //success
                  form.find("input[type=text], input[type=email], input[type=tel], input[type=number], textarea").val("");//reset
                }
                $( "#SubmitContact" ).fadeIn('fast', function(){
                  $( '#loader_gif' ).remove();
                  grecaptcha.reset();
                });
              });

        }
        });      

    }
  }
}

</script>


// WEBPACK FOOTER //
// src/views/ContactUs.vue